import { Component, Input, OnInit } from '@angular/core';
import { AppMessage } from 'src/app/models/app-message';

@Component({
  selector: 'app-gdpr-details',
  templateUrl: './gdpr-details.component.html',
  styleUrls: ['./gdpr-details.component.css']
})
export class GdprDetailsComponent implements OnInit {
  @Input() data:AppMessage;
  
  constructor() { }

  ngOnInit(): void {
  }

}
